import { EmptyStateFind } from 'ui/illustrations';

import { ModalType, useModalContext } from 'modules/templateEditor/context';
import { displayContent } from '../content';
import {
  MessageContainer,
  StyledTitle,
  StyledMessage,
  StyledSecondaryButton,
  Container,
} from './ContentEditorNotSelected.styled';

export const CONTENT_EDITOR_NOT_SELECTED_TEST_ID = 'content-editor-not-selected-msg';
export const CONTENT_EDITOR_NOT_SELECTED_BUTTON_TEST_ID = 'content-editor-not-selected-msg-button';

export const ContentEditorNotSelected = () => {
  const { openModal } = useModalContext();

  return (
    <Container data-test={CONTENT_EDITOR_NOT_SELECTED_TEST_ID}>
      <MessageContainer>
        <EmptyStateFind height={296.5} width={296.5} />
        <StyledTitle>{displayContent.headerOpenContentEditorSelector}</StyledTitle>
        <StyledMessage>{displayContent.strOpenContentEditorSelector}</StyledMessage>
        <StyledSecondaryButton
          data-test={CONTENT_EDITOR_NOT_SELECTED_BUTTON_TEST_ID}
          onClick={() => openModal(ModalType.SelectContentEditorModals)}
        >
          {displayContent.btnOpenContentEditorSelector}
        </StyledSecondaryButton>
      </MessageContainer>
    </Container>
  );
};
